"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  defaultTranslations: true,
  translationsNamespace: true
};
Object.defineProperty(exports, "defaultTranslations", {
  enumerable: true,
  get: function () {
    return _defaultTranslations.defaultTranslations;
  }
});
Object.defineProperty(exports, "translationsNamespace", {
  enumerable: true,
  get: function () {
    return _defaultTranslations.translationsNamespace;
  }
});
var _defaultTranslations = require("./constants/defaultTranslations");
var _RatingAndReviewDialogController = require("./containers/RatingAndReviewDialogController");
Object.keys(_RatingAndReviewDialogController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _RatingAndReviewDialogController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RatingAndReviewDialogController[key];
    }
  });
});
